import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserSeletInfo } from '@app/_alchemint/alchemint_composite_requests';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
  styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public userSeletInfo: UserSeletInfo, public dialogRef: MatDialogRef<YesNoDialogComponent>,) { 
    
  }

  
  ngOnInit(): void {
  }
  
  onNoClick(): void {
    this.dialogRef.close();
   
  } 
}
